import { Injectable } from "@angular/core";
import * as Notiflix from "notiflix";
import { Notify } from "notiflix";
// import { StrongFBLocaleService } from "src/app/StrongFB/services/StrongFB-locale.service";

export type NotifyMode = 'success' | 'failure' | 'info' | 'warning';

export type NotifyCssAnimationStyle = 'fade' | 'zoom' | 'from-right' | 'from-top' | 'from-bottom' | 'from-left';

@Injectable({
	providedIn: 'root',
})

export class NotifyService {

	constructor(
	) {
		Notiflix.Notify.init({
			width: '300px',
			position: 'center-top',
			distance: '10px',
			opacity: 1,
			borderRadius: '10px',
			rtl: true,
			timeout: 3000,
			messageMaxLength: 110,
			backOverlay: false,
			backOverlayColor: 'rgba(0,0,0,0.5)',
			plainText: false,
			showOnlyTheLastOne: true,
			clickToClose: true,
			pauseOnHover: false,
			ID: 'NotiflixNotify',
			className: 'notiflix-notify',
			zindex: 4001,
			fontFamily: 'IranSans FD',
			fontSize: '14px',
			cssAnimation: true,
			cssAnimationDuration: 400,
			cssAnimationStyle: 'fade',
			closeButton: false,
			useIcon: true,
			useFontAwesome: true,
			fontAwesomeIconStyle: 'basic',
			fontAwesomeIconSize: '30px',
			success: {
				background: '#D5F4E3',
				textColor: '#2dc82c',
				childClassName: 'notiflix-notify-success',
				notiflixIconColor: 'rgba(0,0,0,0.2)',
				fontAwesomeClassName: 'fal fa-check-circle success-notif-icon',
				fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
				backOverlayColor: 'rgba(50,198,130,0.2)',
			},
			failure: {
				background: '#f8d4d4',
				textColor: '#EA5455',
				childClassName: 'notiflix-notify-failure',
				notiflixIconColor: '#EA5455',
				fontAwesomeClassName: 'fal fa-exclamation-triangle failure-notif-icon',
				fontAwesomeIconColor: '#EA5455',
				backOverlayColor: 'rgba(255,85,73,0.2)',
			},
			warning: {
				background: '#FFF4D7',
				textColor: '#ffb200',
				childClassName: 'notiflix-notify-warning',
				notiflixIconColor: 'rgba(0,0,0,0.2)',
				fontAwesomeClassName: 'fal fa-exclamation-circle warning-notif-icon',
				fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
				backOverlayColor: 'rgba(238,191,49,0.2)',
			},
			info: {
				background: '#D3D9E0',
				textColor: '#214063',
				childClassName: 'notiflix-notify-info',
				notiflixIconColor: 'rgba(0,0,0,0.2)',
				fontAwesomeClassName: 'fal fa-exclamation-circle info-notif-icon',
				fontAwesomeIconColor: 'rgba(0,0,0,0.2)',
				backOverlayColor: 'rgba(38,192,211,0.2)',
			},
		});
	}
	notify(options: {
		mode?: NotifyMode;
		text: string;
		callback?: () => any;
		timeout?: number;
		cssAnimationStyle?: NotifyCssAnimationStyle;
		rtl?: boolean;
		clickToClose?: boolean;
	}) {
		// =>set defaults
		if (!options.mode) options.mode = 'info';
		if (!options.callback) options.callback = () => { };
		if (!options.timeout) options.timeout = 1500;
		if (!options.cssAnimationStyle) options.cssAnimationStyle = 'fade';
		if (options.rtl === undefined) options.rtl = true;
		if (options.clickToClose === undefined) options.clickToClose = true;
		// =>show notification
		Notify[options.mode](options.text, {
			cssAnimationStyle: options.cssAnimationStyle,
			rtl: options.rtl,
		});
	}

	notifyfunction(text: string, mode: NotifyMode = 'info', timeout = 1500, cssAnimationStyle: NotifyCssAnimationStyle = 'fade') {
		this.notify({
			mode,
			text,
			timeout,
			cssAnimationStyle,
		});
	}
}